import React, { FunctionComponent, ImgHTMLAttributes } from 'react';
import Icon from '../icon/icon-component';
import algeria from './images/algeria.png';
import angola from './images/angola.png';
import argentina from './images/argentina.png';
import azerbaijan from './images/azerbaijan.png';
import bahrain from './images/bahrain.png';
import benin from './images/benin.png';
import botswana from './images/botswana.png';
import bozniaHerzegovina from './images/boznia-and-hezegovina.png';
import brazil from './images/brazil.png';
import bulgaria from './images/bulgaria.png';
import burkinafaso from './images/burkina-faso.png';
import burundi from './images/burundi.png';
import cameroon from './images/cameroon.png';
import canada from './images/canada.png';
import caperverde from './images/cape-verde.png';
import centralafricanrepublic from './images/central-african-republic.png';
import chad from './images/chad.png';
import chile from './images/chile.png';
import comores from './images/comores.png';
import congo from './images/congo.png';
import croatia from './images/croatia.png';
import cyprus from './images/cyprus.png';
import democraticrepublicofcongo from './images/democratic-republic-of-congo.png';
import egypt from './images/egypt.png';
import equatorialguinea from './images/equatorial-guinea.png';
import estonia from './images/estonia.png';
import ethiopia from './images/ethiopia.png';
import finland from './images/finland.png';
import gabon from './images/gabon.png';
import gambia from './images/gambia.png';
import georgia from './images/georgia.png';
import ghana from './images/ghana.png';
import greece from './images/greece.png';
import guineabissau from './images/guinea-bissau.png';
import guinea from './images/guinea.png';
import india from './images/india.png';
import iraq from './images/iraq.png';
import israel from './images/israel.png';
import ivorycoast from './images/ivory-coast.png';
import jordan from './images/jordan.png';
import kazakhstan from './images/kazakhstan.png';
import kenya from './images/kenya.png';
import kuwait from './images/kuwait.png';
import latvia from './images/latvia.png';
import lebanon from './images/lebanon.png';
import lesotho from './images/lesotho.png';
import liberia from './images/liberia.png';
import libya from './images/libya.png';
import lithuania from './images/lithuania.png';
import macao from './images/macao.png';
import madagascar from './images/madagascar.png';
import malawi from './images/malawi.png';
import mali from './images/mali.png';
import malta from './images/malta.png';
import mauritius from './images/mauritius.png';
import mexico from './images/mexico.png';
import montenegro from './images/montenegro.png';
import morocco from './images/morocco.png';
import mozambique from './images/mozambique.png';
import namibia from './images/namibia.png';
import niger from './images/niger.png';
import nigeria from './images/nigeria.png';
import oman from './images/oman.png';
import pakistan from './images/pakistan.png';
import peru from './images/peru.png';
import qatar from './images/qatar.png';
import romania from './images/romania.png';
import russia from './images/russia.png';
import rwanda from './images/rwanda.png';
import saotome from './images/sao-tome.png';
import saudiarabia from './images/saudi-arabia.png';
import senegal from './images/senegal.png';
import serbia from './images/serbia.png';
import seychells from './images/seychelles.png';
import sierreleone from './images/sierre-leone.png';
import slovakia from './images/slovakia.png';
import southafrica from './images/south-africa.png';
import southsudan from './images/south-sudan.png';
import spain from './images/spain.png';
import swaizland from './images/swaziland.png';
import tanzania from './images/tanzania.png';
import togo from './images/togo.png';
import tunisia from './images/tunisia.png';
import turkey from './images/turkey.png';
import turkmenistan from './images/turkmenistan.png';
import uae from './images/uae.png';
import uganda from './images/uganda.png';
import uk from './images/uk.png';
import ukraine from './images/ukraine.png';
import us from './images/us.png';
import uzbekistan from './images/uzbekistan.png';
import zambia from './images/zambia.png';
import zimbabwe from './images/zimbabwe.png';

type FlagIconProps = {
  /**
   * <pre>
   * 'algeria'                              | 'dz'|
   * 'angola'                               | 'ao'|
   * 'argentina'                            | 'ar'|
   * 'azerbaijan'                           | 'az'|
   * 'bahrain'                              | 'bh'|
   * 'benin'                                | 'bj'|
   * 'bosniaherzegovina'                    | 'ba'|
   * 'botswana'                             | 'bw'|
   * 'brazil'                               | 'br'|
   * 'burkinafaso'                          | 'bf'|
   * 'bulgaria'                             | 'bg'|
   * 'burundi'                              | 'bi'|
   * 'cameroon'                             | 'cm'|
   * 'canada'                               | 'ca'|
   * 'caperverde'                           | 'cv'|
   * 'centralafricanrepublic'               | 'cf'|
   * 'chad'                                 | 'td'|
   * 'chile'                                | 'cl'|
   * 'comores'                              | 'km'|
   * 'congo'                                | 'cg'|
   * 'croatia'                              | 'hr'|
   * 'cyprus'                               | 'cy'|
   * 'democraticrepublicofcongo'            | 'cd'|
   * 'egypt'                                | 'eg'|
   * 'equatorialguinea'                     | 'gq'|
   * 'estonia'                              | 'ee'|
   * 'ethiopia'                             | 'et'|
   * 'export'                               | 'ex'|
   * 'finland'                              | 'fi'|
   * 'gabon'                                | 'ga'|
   * 'gambia'                               | 'gm'|
   * 'georgia'                              | 'ge'|
   * 'ghana'                                | 'gh'|
   * 'greece'                               | 'el'|
   * 'guinea'                               | 'gn'|
   * 'guineabissau'                         | 'gw'|
   * 'india'                                | 'in'|
   * 'iraq'                                 | 'iq'|
   * 'israel'                               | 'il'|
   * 'ivorycoast'                           | 'ci'|
   * 'jordan'                               | 'jo'|
   * 'kazakhstan'                           | 'kz'|
   * 'kenya'                                | 'ke'|
   * 'kuwait'                               | 'kw'|
   * 'latvia'                               | 'lv'|
   * 'lebanon'                              | 'lb'|
   * 'liberia'                              | 'lr'|
   * 'libya'                                | 'ly'|
   * 'lesotho'                              | 'ls'|
   * 'lithuania'                            | 'lt'|
   * 'macao'                                | 'mo'|
   * 'madagascar'                           | 'mg'|
   * 'malawi'                               | 'mw'|
   * 'mali'                                 | 'ml'|
   * 'malta'                                | 'mt'|
   * 'mauritius'                            | 'mt'|
   * 'madagascar'                           | 'mu'|
   * 'mexico'                               | 'mx'|
   * 'montenegro'                           | 'me'|
   * 'morocco'                              | 'ma'|
   * 'mozambique'                           | 'mz'|
   * 'namibia'                              | 'na'|
   * 'niger'                                | 'ne'|
   * 'nigeria'                              | 'ng'|
   * 'oman'                                 | 'om'|
   * 'pakistan'                             | 'pk'|
   * 'peru'                                 | 'pe'|
   * 'qatar'                                | 'qa'|
   * 'romania'                              | 'ro'|
   * 'russia'                               | 'ru'|
   * 'rwanda'                               | 'rw'|
   * 'saudiarabia'                          | 'sa'|
   * 'saotome'                              | 'st'|
   * 'senegal'                              | 'sn'|
   * 'serbia'                               | 'rs'|
   * 'seychells'                            | 'sc'|
   * 'sierreleone'                          | 'sl'|
   * 'slovakia'                             | 'sk'|
   * 'southafrica'                          | 'za'|
   * 'southsudan'                           | 'ss'|
   * 'spain'                                | 'es'|
   * 'swaizland'                            | 'sz'|
   * 'tanzania'                             | 'tz'|
   * 'togo'                                 | 'tg'|
   * 'tunisia'                              | 'tn'|
   * 'turkey'                               | 'tr'|
   * 'turkmenistan'                         | 'tm'|
   * 'uae'                                  | 'ae'|
   * 'uganda'                               | 'ug'|
   * 'uk'                                   | 'en'|
   * 'ukraine'                              | 'ua'|
   * 'us'                                   | 'us'|
   * 'uzbekistan'                           | 'uz'|
   * 'zambia'                               | 'zm'|
   * 'zimbabwe '                            | 'zw'
   *
   * </pre>
   */
  name:
    | 'algeria'
    | 'dz'
    | 'angola'
    | 'ao'
    | 'argentina'
    | 'ar'
    | 'azerbaijan'
    | 'az'
    | 'bahrain'
    | 'bh'
    | 'benin'
    | 'bj'
    | 'bosniaherzegovina'
    | 'ba'
    | 'botswana'
    | 'bw'
    | 'brazil'
    | 'br'
    | 'bulgaria'
    | 'bg'
    | 'burkinafaso'
    | 'bf'
    | 'burundi'
    | 'bi'
    | 'cameroon'
    | 'cm'
    | 'canada'
    | 'ca'
    | 'caperverde'
    | 'cv'
    | 'centralafricanrepublic'
    | 'cf'
    | 'chad'
    | 'td'
    | 'chile'
    | 'cl'
    | 'comores'
    | 'km'
    | 'congo'
    | 'cg'
    | 'croatia'
    | 'hr'
    | 'cyprus'
    | 'cy'
    | 'democraticrepublicofcongo'
    | 'cd'
    | 'egypt'
    | 'eg'
    | 'equatorialguinea'
    | 'gq'
    | 'estonia'
    | 'ee'
    | 'ethiopia'
    | 'et'
    | 'export'
    | 'ex'
    | 'finland'
    | 'fi'
    | 'gabon'
    | 'ga'
    | 'gambia'
    | 'gm'
    | 'georgia'
    | 'ge'
    | 'ghana'
    | 'gh'
    | 'greece'
    | 'el'
    | 'guinea'
    | 'gn'
    | 'guineabissau'
    | 'gw'
    | 'india'
    | 'in'
    | 'iraq'
    | 'iq'
    | 'israel'
    | 'il'
    | 'ivorycoast'
    | 'ci'
    | 'jordan'
    | 'jo'
    | 'kazakhstan'
    | 'kz'
    | 'kenya'
    | 'ke'
    | 'kuwait'
    | 'kw'
    | 'latvia'
    | 'lv'
    | 'lebanon'
    | 'lb'
    | 'liberia'
    | 'lr'
    | 'libya'
    | 'ly'
    | 'lesotho'
    | 'ls'
    | 'lithuania'
    | 'lt'
    | 'macao'
    | 'mo'
    | 'madagascar'
    | 'mg'
    | 'malawi'
    | 'mw'
    | 'mali'
    | 'ml'
    | 'malta'
    | 'mt'
    | 'mauritius'
    | 'mu'
    | 'mexico'
    | 'mx'
    | 'montenegro'
    | 'ma'
    | 'morocco'
    | 'me'
    | 'mozambique'
    | 'mz'
    | 'namibia'
    | 'na'
    | 'niger'
    | 'ne'
    | 'nigeria'
    | 'ng'
    | 'oman'
    | 'om'
    | 'pakistan'
    | 'pk'
    | 'peru'
    | 'pe'
    | 'qatar'
    | 'qa'
    | 'romania'
    | 'ro'
    | 'russia'
    | 'ru'
    | 'rwanda'
    | 'rw'
    | 'saudiarabia'
    | 'sa'
    | 'saotome'
    | 'st'
    | 'senegal'
    | 'sn'
    | 'serbia'
    | 'rs'
    | 'seychells'
    | 'sc'
    | 'sierreleone'
    | 'sl'
    | 'slovakia'
    | 'sk'
    | 'southafrica'
    | 'za'
    | 'southsudan'
    | 'ss'
    | 'spain'
    | 'es'
    | 'swaizland'
    | 'sz'
    | 'tanzania'
    | 'tz'
    | 'togo'
    | 'tg'
    | 'tunisia'
    | 'tn'
    | 'turkey'
    | 'tr'
    | 'turkmenistan'
    | 'tm'
    | 'uae'
    | 'ae'
    | 'uganda'
    | 'ug'
    | 'uk'
    | 'en'
    | 'ukraine'
    | 'ua'
    | 'us'
    | 'us'
    | 'uzbekistan'
    | 'uz'
    | 'zambia'
    | 'zm'
    | 'zimbabwe '
    | 'zw'
    | string;
  width?: number;
  height?: number;
} & ImgHTMLAttributes<HTMLImageElement>;

export const FlagIcon: FunctionComponent<FlagIconProps> = ({ width = 24, height = 24, name, ...htmlAttributes }) => {
  if (name === 'export' || name === 'ex') return <Icon name='globe' width={width} height={height}></Icon>;
  return <img src={getFlag(name)} alt={`flag-${name}`} width={width} height={height} {...htmlAttributes} />;

  function getFlag(name: string): string {
    switch (name) {
      case 'dz':
      case 'algeria':
        return algeria;
      case 'ao':
      case 'angola':
        return angola;
      case 'ar':
      case 'argentina':
        return argentina;
      case 'az':
      case 'azerbaijan':
        return azerbaijan;
      case 'bh':
      case 'bahrain':
        return bahrain;
      case 'bj':
      case 'benin':
        return benin;
      case 'ba':
      case 'bosniaherzegovina':
        return bozniaHerzegovina;
      case 'bw':
      case 'botswana':
        return botswana;
      case 'br':
      case 'brazil':
        return brazil;
      case 'bg':
      case 'bulgaria':
        return bulgaria;
      case 'bi':
      case 'burkinafaso':
        return burkinafaso;
      case 'bf':
      case 'burundi':
        return burundi;
      case 'cm':
      case 'cameroon':
        return cameroon;
      case 'cv':
      case 'caperverde':
        return caperverde;
      case 'ca':
      case 'canada':
        return canada;
      case 'cf':
      case 'centralafricanrepublic':
        return centralafricanrepublic;
      case 'td':
      case 'chad':
        return chad;
      case 'cl':
      case 'chile':
        return chile;
      case 'km':
      case 'comores':
        return comores;
      case 'cg':
      case 'congo':
        return congo;
      case 'hr':
      case 'croatia':
        return croatia;
      case 'cy':
      case 'cyprus':
        return cyprus;
      case 'cd':
      case 'democraticrepublicofcongo':
        return democraticrepublicofcongo;
      case 'eg':
      case 'egypt':
        return egypt;
      case 'gq':
      case 'equatorialguinea':
        return equatorialguinea;
      case 'ee':
      case 'estonia':
        return estonia;
      case 'et':
      case 'ethiopia':
        return ethiopia;
      case 'fi':
      case 'finland':
        return finland;
      case 'ga':
      case 'gabon':
        return gabon;
      case 'gm':
      case 'gambia':
        return gambia;
      case 'ge':
      case 'georgia':
        return georgia;
      case 'gh':
      case 'ghana':
        return ghana;
      case 'el':
      case 'greece':
        return greece;
      case 'gn':
      case 'guinea':
        return guinea;
      case 'gw':
      case 'guineabissau':
        return guineabissau;
      case 'in':
      case 'india':
        return india;
      case 'iq':
      case 'iraq':
        return iraq;
      case 'il':
      case 'israel':
        return israel;
      case 'ci':
      case 'ivorycoast':
        return ivorycoast;
      case 'jo':
      case 'jordan':
        return jordan;
      case 'kz':
      case 'kazakhstan':
        return kazakhstan;
      case 'ke':
      case 'kenya':
        return kenya;
      case 'kw':
      case 'kuwait':
        return kuwait;
      case 'lv':
      case 'latvia':
        return latvia;
      case 'lb':
      case 'lebanon':
        return lebanon;
      case 'ls':
      case 'lesotho':
        return lesotho;
      case 'lr':
      case 'liberia':
        return liberia;
      case 'ly':
      case 'libya':
        return libya;
      case 'lt':
      case 'lithuania':
        return lithuania;
      case 'mg':
      case 'madagascar':
        return madagascar;
      case 'mw':
      case 'malawi':
        return malawi;
      case 'ml':
      case 'mali':
        return mali;
      case 'mo':
      case 'macao':
        return macao;
      case 'mt':
      case 'malta':
        return malta;
      case 'mu':
      case 'mauritius':
        return mauritius;
      case 'mx':
      case 'mexico':
        return mexico;
      case 'me':
      case 'montenegro':
        return montenegro;
      case 'ma':
      case 'morocco':
        return morocco;
      case 'mz':
      case 'mozambique':
        return mozambique;
      case 'na':
      case 'namibia':
        return namibia;
      case 'ne':
      case 'niger':
        return niger;
      case 'ng':
      case 'nigeria':
        return nigeria;
      case 'om':
      case 'oman':
        return oman;
      case 'pk':
      case 'pakistan':
        return pakistan;
      case 'pe':
      case 'peru':
        return peru;
      case 'qa':
      case 'qatar':
        return qatar;
      case 'ro':
      case 'romania':
        return romania;
      case 'ru':
      case 'russia':
        return russia;
      case 'rw':
      case 'rwanda':
        return rwanda;
      case 'st':
      case 'saotome':
        return saotome;
      case 'sn':
      case 'senegal':
        return senegal;
      case 'rs':
      case 'serbia':
        return serbia;
      case 'sc':
      case 'seychells':
        return seychells;
      case 'sa':
      case 'saudiarabia':
        return saudiarabia;
      case 'sl':
      case 'sierreleone':
        return sierreleone;
      case 'sk':
      case 'slovakia':
        return slovakia;
      case 'za':
      case 'southafrica':
        return southafrica;
      case 'ss':
      case 'southsudan':
        return southsudan;
      case 'es':
      case 'spain':
        return spain;
      case 'sz':
      case 'swaizland':
        return swaizland;
      case 'tz':
      case 'tanzania':
        return tanzania;
      case 'tg':
      case 'togo':
        return togo;
      case 'tn':
      case 'tunisia':
        return tunisia;
      case 'tr':
      case 'turkey':
        return turkey;
      case 'tm':
      case 'turkmenistan':
        return turkmenistan;
      case 'ae':
      case 'uae':
        return uae;
      case 'ug':
      case 'uganda':
        return uganda;
      case 'en':
      case 'uk':
        return uk;
      case 'ua':
      case 'ukraine':
        return ukraine;
      case 'us':
        return us;
      case 'uz':
      case 'uzbekistan':
        return uzbekistan;
      case 'zm':
      case 'zambia':
        return zambia;
      case 'zw':
      case 'zimbabwe ':
        return zimbabwe;
    }
    return '';
  }
};

export default FlagIcon;
